import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfigurarCuentasService } from '../services/configurar-cuentas.service';
import { ConfigurarCuentaAdministrativaDTO } from '../dto/configurar-cuenta-administrativaDTO';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { DataUsuario } from '../dto/data-usuarioDTO';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { UtilService } from '../../../services/util.service';
import { Constants } from '../../../constants/constants';
import { AutenticacionService } from '../../auth/services/autenticacion.service';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-configurar-cuenta-administrativa',
  templateUrl: './configurar-cuenta-administrativa.component.html',
  styleUrl: './configurar-cuenta-administrativa.component.scss',
})
export class ConfigurarCuentaAdministrativaComponent implements OnInit {
  // Formularios
  preferenciasForm!: FormGroup;
  // variables
  editandoCorreo = false;
  dataUsuario!: DataUsuario;
  rolUsuario!: any;

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;
  // Multilenguaje
  configurarText: any = {};
  comunText: any = {};
  constructor(
    private fb: FormBuilder,
    private _cuentaService: ConfigurarCuentasService,
    private alertService: AlertaModalService,
    private utilService: UtilService,
    private autenticacionService: AutenticacionService,
    private readonly translate: TranslateService
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.translate.stream('configuracion-cuenta'),
      this.translate.stream('comun-label'),
    ]).subscribe(([configurarText, comunLabelText]) => {
      for (const key of Object.keys(configurarText)) {
        this.configurarText[key] = configurarText[key];
      }
      for (const key of Object.keys(comunLabelText)) {
        this.comunText[key] = comunLabelText[key];
      }
    });
    this.obtenerDataUsuario();
    this.preferenciasForm = this.fb.group({
      id: [null],
      informesMensual: [true],
      alertasMetricas: [true],
      recibirNotificacionesCorreo: [false],
      email: [
        { value: '', disabled: true },
        [
          Validators.required,
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
      ],
    });
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: 'Configuración de cuenta',
      descripcionPantalla:
        'En esta pantalla usted podrá editar su información personal y ' +
        'cambiar sus preferencias',
      pasos: [],
    };
    this.utilService.changeInfoPantalla(this.infoPantalla);
  }
  /**
   * Metodos usuario logeado
   */
  obtenerDataUsuario() {
    const data = sessionStorage.getItem('user_information_session');
    const dataRol = sessionStorage.getItem('user_type');
    this.rolUsuario =
      dataRol != null
        ? JSON.parse(dataRol).Nombre
        : this.dataUsuario.tipoUsuario?.Tipo_Usuario;
    this.dataUsuario = data != null ? JSON.parse(data) : null;
    this.getDataUser(this.dataUsuario.idUsuario);
  }

  getDataUser(idUsuario: number) {
    this._cuentaService
      .getDataPersonal(idUsuario)
      .subscribe((response: any) => {
        if (response.status == 200) {
          this.preferenciasForm
            .get('informesMensual')
            ?.setValue(response.data.Usuario.Recibir_notificaciones_informe);
          this.preferenciasForm
            .get('alertasMetricas')
            ?.setValue(response.data.Usuario.Recibir_notificaciones_metricas);
          this.preferenciasForm
            .get('recibirNotificacionesCorreo')
            ?.setValue(response.data.Usuario.Recibir_notificaciones_correo);
          this.preferenciasForm
            .get('email')
            ?.setValue(response.data.Usuario.Correo_electronico_verificacion);
        } else {
          this.alertService.error(response.message);
        }
      });
  }

  getNombreUsuario() {
    const arrayAux = [this.dataUsuario];
    let nombreUsuario = '';
    arrayAux.forEach((elemento: DataUsuario) => {
      nombreUsuario =
        this.validarNull(elemento.primerNombre) +
        ' ' +
        this.validarNull(elemento.segundoNombre) +
        ' ' +
        this.validarNull(elemento.primerApellido) +
        ' ' +
        this.validarNull(elemento.segundoApellido);
    });
    return nombreUsuario;
  }

  getInicialesNombreUsuario() {
    const arrayAux = [this.dataUsuario];
    let nombreUsuario = '';
    arrayAux.forEach((elemento: DataUsuario) => {
      nombreUsuario =
        this.validarNull(elemento.primerNombre) +
        ' ' +
        this.validarNull(elemento.primerApellido);
    });
    return nombreUsuario;
  }

  getNumeroDocumento(): string {
    return (
      this.dataUsuario.tipoDocumento + ' : ' + this.dataUsuario.identificacion
    );
  }

  validarNull(elemento: string): string {
    return elemento ?? '';
  }

  getTipoUsuario() {
    return 'Usuario ' + this.rolUsuario;
  }

  esUsuarioAdministrador(): boolean {
    return (
      this.dataUsuario.tipoUsuario?.Tipo_Usuario ===
        Constants.TIPOS_USUARIO.ADMIN_LIDER ||
      this.dataUsuario.tipoUsuario?.Tipo_Usuario ===
        Constants.TIPOS_USUARIO.ADMIN_OBSERVATORIO
    );
  }

  guardar() {
    const dataRol = sessionStorage.getItem('user_type');
    let idRolUsuario =
      dataRol != null
        ? JSON.parse(dataRol).Id
        : this.dataUsuario.tipoUsuario?.Tipo_Usuario;

    const json: ConfigurarCuentaAdministrativaDTO = {
      id: this.dataUsuario.idUsuario,
      tipoUsuarioId: idRolUsuario ?? 0,
      recibirNotificacionesInforme:
        this.preferenciasForm.get('informesMensual')?.value,
      recibirNotificacionesMetricas:
        this.preferenciasForm.get('alertasMetricas')?.value,
      recibirNotificacionesCorreo: this.preferenciasForm.get(
        'recibirNotificacionesCorreo'
      )?.value,
      correoElectronicoVerificacion: this.preferenciasForm.get('email')?.value,
    };
    this._cuentaService
      .saveConfiguracionCuentaAdministrativa(json)
      .subscribe((response: any) => {
        if (response.status == 200) {
          this.alertService.exito(`${response.message}`);
          this.getDataUser(this.dataUsuario.idUsuario);
        } else {
          this.alertService.error(response.message);
        }
      });
  }

  // Método para iniciar la edición
  editarCorreo() {
    this.editandoCorreo = true;
    this.preferenciasForm.get('email')?.enable();
  }

  // Método para guardar el correo modificado
  guardarCorreo() {
    const json = {
      id: this.dataUsuario.idUsuario,
      correoElectronicoVerificacion: this.preferenciasForm.get('email')?.value,
    };
    if (this.preferenciasForm.valid) {
      this.editandoCorreo = false;
      this.preferenciasForm.get('email')?.disable();
      this._cuentaService
        .saveCorreoVerificacion(json)
        .subscribe((response: any) => {
          if (response.status == 200) {
            this.alertService.exito(`${response.message}`);
            this.getDataUser(this.dataUsuario.idUsuario);
          } else {
            this.alertService.error(response.message);
          }
        });
    }
  }

  // Función que valida los campos de acuerdo al formulario
  validateField(form: FormGroup, field: string): boolean {
    return (
      ((form.get(field)?.dirty || form.get(field)?.touched) &&
        form.get(field)?.invalid) ||
      false
    );
  }

  enviarMensajeCambiarContrasena(): void {
    this.autenticacionService.actualizarContrasena().subscribe({
      next: () => {
        this.alertService.exito(
          this.configurarText['cambiar-contrasenia-tituloModal'],
          this.configurarText['cambiar-contrasenia-modal']
        );
      },
      error: () => {
        this.alertService.error(
          this.configurarText['error-modal-titulo'],
          this.configurarText['error-modal']
        );
      },
    });
  }
}
